import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";

function LocationDisplay(props) {
  return (
    <Row>
      <Col className="pb-4">
        <h3>
          {props.location.name}
        </h3>
        <Button onClick={() => props.travelToNext()} disabled={props.disabled}> Next </Button>
      </Col>
    </Row>
  );
}

export default LocationDisplay;
